module.exports = __webpack_public_path__ + "static/media/no-reports-img.6e4bfd80.svg";